var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(_vm._s(_vm.title)),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("common.close"),
                  expression: "$ct('common.close')",
                },
              ],
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { staticClass: "mr", attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        { staticClass: "content" },
        [
          _vm.ready
            ? _c("app-sale-edit", {
                attrs: { value: _vm.sale, "contact-group-id": 1 },
                on: {
                  input: function ($event) {
                    return _vm.onSaved($event)
                  },
                  close: function ($event) {
                    return _vm.close()
                  },
                  state: function ($event) {
                    _vm.state = $event
                  },
                },
              })
            : _c(
                "div",
                { staticClass: "loading" },
                [_c("w-progress-circular")],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }